import styled from 'theme';

export const ReportsWrapper = styled.div``;
